function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_159",
  "data-name": "Path 159",
  d: "M8,73.787,42.553,9a1.907,1.907,0,0,1,3.389.045L57.9,32.961Z",
  transform: "translate(-8 5.596)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_160",
  "data-name": "Path 160",
  d: "M8,81.366,20.579,3.8a2.139,2.139,0,0,1,4.008-.646l24.24,46.46Z",
  transform: "translate(-8 -2.001)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_161",
  "data-name": "Path 161",
  d: "M8.008,67.388l.454-.356L48.22,34.5,37.006,13.012Z",
  transform: "translate(-7.99 11.963)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_162",
  "data-name": "Path 162",
  d: "M8,69.948,68.482,11.628a2.163,2.163,0,0,1,3.643,1.241l8.456,57.08L46.558,89.778a4.542,4.542,0,0,1-4.448,0Z",
  transform: "translate(-8 9.435)"
});

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-firebase",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.58,
    height: 99.795,
    viewBox: "0 0 72.58 99.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.751d9d1e.svg";
export { ForwardRef as ReactComponent };